export const organizationIds = {
    undefined: 0,
    // NCE
    nce: 1,
    // Комитет
    committee: 2
}